import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';

import { useButton } from '../../hooks/useButton';
import useForkRef from '../../hooks/useForkRef';
import { getDomAttributes } from '../../utils';
import { BaseIconButtonProps } from './types';

interface Params {
  disabled?: boolean;
  focusVisible?: boolean;
}

const getButtonClasses = ({ disabled, focusVisible }: Params) =>
  cn({ 'Ly-focusVisible': focusVisible, 'Ly-disabled': disabled });

const BaseIconButton = forwardRef<HTMLButtonElement, BaseIconButtonProps>((props, forwardedRef) => {
  const { children, className, component, disabled, href, style, target, to } = props;

  const { getRootProps, focusVisible } = useButton(props);
  const { ref: rootRef, ...rootProps } = getRootProps();
  const ref = useForkRef(forwardedRef, rootRef);
  const link = href || to;
  const Component = component || (link ? 'a' : 'button');

  return (
    <Component
      ref={ref}
      className={cn('Ly-IconButton', getButtonClasses({ disabled, focusVisible }), className)}
      href={link}
      style={style}
      target={target}
      {...getDomAttributes(props)}
      {...rootProps}>
      {children}
    </Component>
  );
});

export default BaseIconButton;
